import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileMenu from "../Navigation/ProfileMenu";
import HamburgerMenu from "../Navigation/HamburgerMenu";
import LanguageSelector from "./LanguageSelector";
import { useKeycloak } from "@react-keycloak/web";

export default function Header() {
  //const { auth, setAuth } = useAuth();
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();

  const handleLogoutClick = async () => {
    //setAuth();
    //await logout();
    await keycloak.logout();
    window.location.reload();
  };

  return (
    <div className="header" data-testid="component-header-div">
      <div className="items" data-testid="component-header-upper-div">
        {keycloak.authenticated ? <HamburgerMenu /> : <div></div>}
        <Link to={"/"}>{t("app_name")}</Link>
        <div className="left-items">
          <LanguageSelector />
          {keycloak.authenticated ? (
            <ProfileMenu onLogoutClick={handleLogoutClick} />
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
}
